import { render, staticRenderFns } from "./order-review.vue?vue&type=template&id=1a462464"
import script from "./order-review.vue?vue&type=script&lang=js"
export * from "./order-review.vue?vue&type=script&lang=js"
import style0 from "./order-review.vue?vue&type=style&index=0&id=1a462464&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports